import React from 'react'
import { check, line, services1 } from '../../assets/imagesPath'

const BusinessSupport = () => {
    const items = [
        "Annual income below $100,000",
        "Business operations under two years.",
        "Demonstrated need for financial assistance.",
    ];
    return (
        <>
            <div className='flex items-center justify-center gap-12 mt-10'>
                <img src={line} alt="" className='h-1 w-7' />
                <p className='text-xl font-bold text-[#818891] '>Grant Overview</p>
                <img src={line} alt="" className='h-1 w-7' />
            </div>
            <div className="text-center py-10 px-4 sm:px-6 lg:px-8">
                <h1 className="text-[4.7rem] md:text-[3.4rem] smallScreens:text-[3rem] font-bold text-gray-800"> Business Support Grant</h1>
                <p className='text-[#6A6A6A] text-[1.8rem] smallScreens:text-[1.2rem] font-normal'>The Business Support Grant is designed to provide financial assistance for small businesses during critical growth stages.</p>
            </div>

            <div className="bg-white py-20 smallScreens:py-6 px-4 sm:px-6 lg:px-8">
                <div className="w-4/5 smallScreens:w-full mx-auto smallScreens:mx-0 flex flex-col md:flex-row items-center gap-40 smallScreens:gap-10">
                    <div className="md:w-4/5 smallScreens:px-0 smallScreens:text-center">
                        <div className='flex items-start justify-start md:mt-4'>
                            <h1 className='font-bold text-[2.4rem] smallScreens:text-[2rem] text-[#121212] smallScreens:mx-auto'>Grant Benefits:</h1>
                        </div>
                        <p className="text-[#64666C] leading-relaxed text-[1.6rem] mt-10 mb-10">
                            Eligible recipients may qualify for adjusted service rates, with Basic Package pricing starting at approximately $150/month for the first six months.
                        </p>
                        <p className='text-[#64666C] leading-relaxed text-[1.6rem] mt-10 mb-10'>The final rate will depend on the scope of services required.</p>
                        <div className="flex items-start mb-10">
                            <div>
                                <h3 className="font-bold text-[2.4rem] smallScreens:text-[2rem] text-[#121212] smallScreens:text-center">
                                    Eligibility Criteria:
                                </h3>
                                <ul className="mt-10 space-y-10 text-gray-700 smallScreens:space-y-6">
                                    {items.map((item, index) => (
                                        <li key={index} className="flex items-center">
                                            <span>
                                                <img
                                                    src={check}
                                                    alt="check"
                                                    className="h-[2rem] w-[2rem] mr-4 smallScreens:h-[1.5rem] smallScreens:w-[1.5rem]"
                                                />
                                            </span>
                                            <span className="text-[#6A6A6A] text-[1.4rem] ml-4 smallScreens:text-[1.2rem]">
                                                {item}
                                            </span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <div className="flex items-start">
                            <div>
                                <h3 className="font-bold text-[2.4rem] smallScreens:text-[2rem] text-[#121212] smallScreens:text-center">
                                    Terms:
                                </h3>
                                <div className="text-gray-600 leading-relaxed text-[1.6rem] mt-4">
                                    <p className='mb-2'>• Financial support applies for six months, after which standard rates resume.</p>
                                    <p>• Eligibility will be reassessed for those wishing to reapply after the initial period</p>
                                </div>
                            </div>
                        </div>
                        <div className="flex items-start mt-10">
                            <div>
                                <h3 className="text-[1.4rem] font-semibold text-gray-900 mb-2">
                                    The Business Support Grant is subject to eligibility evaluation and provides tailored financial assistance to qualifying businesses. Rates are approximate and determined by the scope of services required.
                                </h3>
                            </div>
                        </div>

                    </div>
                    <div className="w-full md:w-2/3 relative smallScreens:px-8">
                        <img
                            src={services1}
                            alt="Professional"
                            className="w-[60.6rem] h-[50.3rem] smallScreens:h-[20rem] object-contain"
                        />
                    </div>
                </div>
                <div className="bg-[#F2F2F282] text-center py-14 px-4 sm:px-6 lg:px-8 rounded-xl w-4/5 mx-auto mt-10">
                    <h1 className="text-[3rem] md:text-[1.6rem] smallScreens:text-[2.6rem] font-bold text-[#000000]">Income Eligibility Disclaimer</h1>
                    <p className='mx-auto text-[#6A6A6A] text-[14px] mt-4'>Eligibility for the Business Support Grant is determined based on a variety of factors, including but not limited to annual income and business operations. While income guidelines are a general consideration, other unique circumstances may also be evaluated to determine qualification. Final eligibility is at the sole discretion of SBAAA LLC and is assessed on a case-by-case basis.</p>
                </div>
            </div>
        </>

    )
}

export default BusinessSupport